var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Table",
    {
      staticClass: "panorama-summary-table",
      staticStyle: { "margin-top": "1rem" }
    },
    [
      _c(
        "TableHeader",
        [
          _c(
            "TableRow",
            _vm._l(_vm.panoramaSummaryColumns, function(
              panoramaSummaryCol,
              index
            ) {
              return _c(
                "TableHead",
                { key: `${panoramaSummaryCol.label}_${index}` },
                [_c("span", [_vm._v(_vm._s(panoramaSummaryCol.label))])]
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "TableBody",
        _vm._l(_vm.panoramaStatusSummaryList, function(panoramaSummary, index) {
          return _c(
            "TableRow",
            { key: `${panoramaSummary.name}_${index}` },
            [
              _c(
                "TableCell",
                {
                  staticClass: "panorama-summary-table-cell",
                  style: _vm.setInvoiceSummaryStatusColor(panoramaSummary.name)
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.translatePanoramaSummaryStatusName(
                          panoramaSummary.name
                        )
                      ) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                {
                  staticClass: "panorama-summary-table-cell",
                  staticStyle: { "text-align": "right" }
                },
                [
                  _c(
                    "div",
                    [
                      panoramaSummary.name.substring(2, 3) === "0" ||
                      ["B", "K", "T"].includes(
                        panoramaSummary.name.substring(2, 3)
                      )
                        ? _c("RenderMoneyColumnValue", {
                            attrs: {
                              value: !["B", "K", "T"].includes(
                                panoramaSummary.name.substring(2, 3)
                              )
                                ? _vm.getTotalAmountByStatusPrefix(
                                    panoramaSummary.name.substring(1, 2),
                                    _vm.panoramaStatusSummaryList
                                  ) || 0
                                : panoramaSummary.total || 0,
                              "max-fraction-digits": 0
                            }
                          })
                        : _vm._e(),
                      _vm._v("\n          |\n          "),
                      _c("RenderPercentageColumnValue", {
                        attrs: { value: panoramaSummary.percentageOfTotal }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                {
                  staticClass: "panorama-summary-table-cell",
                  staticStyle: { "text-align": "right" }
                },
                [
                  _c("RenderMoneyColumnValue", {
                    attrs: {
                      value: panoramaSummary.subtotal,
                      "max-fraction-digits": 0
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                {
                  staticClass: "panorama-summary-table-cell",
                  staticStyle: { "text-align": "right" }
                },
                [
                  _c("RenderPanoramaSummaryInvoiceLine", {
                    attrs: {
                      "invoice-value": _vm.getSumBoletoVeinsByPanoramaList(
                        panoramaSummary.january
                      ),
                      "percentage-invoice-value": _vm.getSumPercentageByPanoramaList(
                        panoramaSummary.january
                      ),
                      status: panoramaSummary.name
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                {
                  staticClass: "panorama-summary-table-cell",
                  staticStyle: { "text-align": "right" }
                },
                [
                  _c("RenderPanoramaSummaryInvoiceLine", {
                    attrs: {
                      "invoice-value": _vm.getSumBoletoVeinsByPanoramaList(
                        panoramaSummary.february
                      ),
                      "percentage-invoice-value": _vm.getSumPercentageByPanoramaList(
                        panoramaSummary.february
                      ),
                      status: panoramaSummary.name
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                {
                  staticClass: "panorama-summary-table-cell",
                  staticStyle: { "text-align": "right" }
                },
                [
                  _c("RenderPanoramaSummaryInvoiceLine", {
                    attrs: {
                      "invoice-value": _vm.getSumBoletoVeinsByPanoramaList(
                        panoramaSummary.march
                      ),
                      "percentage-invoice-value": _vm.getSumPercentageByPanoramaList(
                        panoramaSummary.march
                      ),
                      status: panoramaSummary.name
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                {
                  staticClass: "panorama-summary-table-cell",
                  staticStyle: { "text-align": "right" }
                },
                [
                  _c("RenderPanoramaSummaryInvoiceLine", {
                    attrs: {
                      "invoice-value": _vm.getSumBoletoVeinsByPanoramaList(
                        panoramaSummary.april
                      ),
                      "percentage-invoice-value": _vm.getSumPercentageByPanoramaList(
                        panoramaSummary.april
                      ),
                      status: panoramaSummary.name
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                {
                  staticClass: "panorama-summary-table-cell",
                  staticStyle: { "text-align": "right" }
                },
                [
                  _c("RenderPanoramaSummaryInvoiceLine", {
                    attrs: {
                      "invoice-value": _vm.getSumBoletoVeinsByPanoramaList(
                        panoramaSummary.may
                      ),
                      "percentage-invoice-value": _vm.getSumPercentageByPanoramaList(
                        panoramaSummary.may
                      ),
                      status: panoramaSummary.name
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                {
                  staticClass: "panorama-summary-table-cell",
                  staticStyle: { "text-align": "right" }
                },
                [
                  _c("RenderPanoramaSummaryInvoiceLine", {
                    attrs: {
                      "invoice-value": _vm.getSumBoletoVeinsByPanoramaList(
                        panoramaSummary.june
                      ),
                      "percentage-invoice-value": _vm.getSumPercentageByPanoramaList(
                        panoramaSummary.june
                      ),
                      status: panoramaSummary.name
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                {
                  staticClass: "panorama-summary-table-cell",
                  staticStyle: { "text-align": "right" }
                },
                [
                  _c("RenderPanoramaSummaryInvoiceLine", {
                    attrs: {
                      "invoice-value": _vm.getSumBoletoVeinsByPanoramaList(
                        panoramaSummary.july
                      ),
                      "percentage-invoice-value": _vm.getSumPercentageByPanoramaList(
                        panoramaSummary.july
                      ),
                      status: panoramaSummary.name
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                {
                  staticClass: "panorama-summary-table-cell",
                  staticStyle: { "text-align": "right" }
                },
                [
                  _c("RenderPanoramaSummaryInvoiceLine", {
                    attrs: {
                      "invoice-value": _vm.getSumBoletoVeinsByPanoramaList(
                        panoramaSummary.august
                      ),
                      "percentage-invoice-value": _vm.getSumPercentageByPanoramaList(
                        panoramaSummary.august
                      ),
                      status: panoramaSummary.name
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                {
                  staticClass: "panorama-summary-table-cell",
                  staticStyle: { "text-align": "right" }
                },
                [
                  _c("RenderPanoramaSummaryInvoiceLine", {
                    attrs: {
                      "invoice-value": _vm.getSumBoletoVeinsByPanoramaList(
                        panoramaSummary.september
                      ),
                      "percentage-invoice-value": _vm.getSumPercentageByPanoramaList(
                        panoramaSummary.september
                      ),
                      status: panoramaSummary.name
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                {
                  staticClass: "panorama-summary-table-cell",
                  staticStyle: { "text-align": "right" }
                },
                [
                  _c("RenderPanoramaSummaryInvoiceLine", {
                    attrs: {
                      "invoice-value": _vm.getSumBoletoVeinsByPanoramaList(
                        panoramaSummary.october
                      ),
                      "percentage-invoice-value": _vm.getSumPercentageByPanoramaList(
                        panoramaSummary.october
                      ),
                      status: panoramaSummary.name
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                {
                  staticClass: "panorama-summary-table-cell",
                  staticStyle: { "text-align": "right" }
                },
                [
                  _c("RenderPanoramaSummaryInvoiceLine", {
                    attrs: {
                      "invoice-value": _vm.getSumBoletoVeinsByPanoramaList(
                        panoramaSummary.november
                      ),
                      "percentage-invoice-value": _vm.getSumPercentageByPanoramaList(
                        panoramaSummary.november
                      ),
                      status: panoramaSummary.name
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "TableCell",
                {
                  staticClass: "panorama-summary-table-cell",
                  staticStyle: { "text-align": "right" }
                },
                [
                  _c("RenderPanoramaSummaryInvoiceLine", {
                    attrs: {
                      "invoice-value": _vm.getSumBoletoVeinsByPanoramaList(
                        panoramaSummary.december
                      ),
                      "percentage-invoice-value": _vm.getSumPercentageByPanoramaList(
                        panoramaSummary.december
                      ),
                      status: panoramaSummary.name
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }